module.exports = __webpack_public_path__ + "img/japan-other-heart-diseases-male.8ca20978.png";